import { useParams } from "react-router-dom";
import PageScaffold from "../../../components/PageScaffold";
import { SUBSCRIPTIONS_PAGE_PATH } from "../SubscriptionsPage";
import { useContext, useEffect } from "react";
import AIContext from "../../../contexts/data/AIContext";
import SubscriptionsContext from "../../../contexts/data/SubscriptionsContext";
import { ContextStatus } from '@leedpulse-monorepo/enums';
import { Card } from "antd";
import { AIEditionFormProvider } from "../../../contexts/forms/ai/AIEditionFormContext";
import AIDetails from "../../../components/ai_detail_page/AIDetails";
import { useNavigate } from "react-router-dom";

export const AI_DETAIL_PAGE_PATH = "/ai";
export const AI_DETAIL_PAGE_TITLE = "IA";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface AIDetailPageProps {}

const AIPage: React.FC<AIDetailPageProps> = (_) => {
  const aiContext = useContext(AIContext);
  const subscriptionsContext = useContext(SubscriptionsContext);
  const navigate = useNavigate();

  const { subscriptionId } = useParams<{ subscriptionId: string }>();

  // AI.name is copied from the subscription name at creation and never follows a rename:
  // prefer the live subscription name when we come from its page.
  const sTitle = (subscriptionsContext.selected?.id === subscriptionId && subscriptionsContext.selected?.name) || aiContext.item?.name || '';

  useEffect(() => {
    if (aiContext.status !== ContextStatus.LOADING && subscriptionId) {
      aiContext.fetch(subscriptionId);
    }
    return () => {
      aiContext.reset();
    };
  }, []);

  if(!subscriptionId) {
    navigate(SUBSCRIPTIONS_PAGE_PATH);
    return;
  }

  return (
    <PageScaffold
      title={AI_DETAIL_PAGE_TITLE + ' > ' + sTitle}
      subtitle={"Gérez les paramètres de l'IA associée à l'abonnement"}
      breadcrumbItems={[
        {
          target: SUBSCRIPTIONS_PAGE_PATH,
          title: "Abonnements",
        },
        {
          target: SUBSCRIPTIONS_PAGE_PATH + "/" + subscriptionId,
          title: sTitle,
        },
        {
          title: "IA",
        },
      ]}
    >
      {aiContext.item == null ? (
        <Card loading />
      ) : (
        <AIEditionFormProvider>
          <AIDetails ai={aiContext.item} subscriptionId={subscriptionId} />
        </AIEditionFormProvider>
      )}
    </PageScaffold>
  );
};

export default AIPage;
